<template>
  <div id="modal" class="animated slideInUp">
    <i id="close" class="anyteachicon anyteach-guanbi" @click="close()" />
    <div class="answer">
      <h1>{{ msg.title }}</h1>
      <div v-for="item in msg.content" :key="item.title" class="content">
        <h2 v-if="item.title">{{ item.title }}</h2>
        <p v-html="item.content" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Popup",
  props: ["msg"],
  data() {
    return {}
  },
  created() {
    document.body.classList.add("noscroll")
  },
  methods: {
    close() {
      document.getElementById("modal").classList.remove("slideInUp")
      document.getElementById("modal").classList.add("slideOutDown")
      document.body.classList.remove("noscroll")
      setTimeout(() => {
        this.$emit("close")
      }, 300)
    },
  },
}
</script>
<style lang="scss">
// @import "../../../static/css/public.scss";

.animated {
  animation-delay: 0s !important;
  animation-duration: 0.3s !important;
}

#modal {
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background: white;
  overflow: scroll !important;
  z-index: 998;
  margin: 0;
  .answer {
    padding: 0 5%;
    h1 {
      font-size: 25px;
      padding-bottom: 20px;
      margin-bottom: 20px;
      font-weight: bold;
      border-bottom: 1px solid #eee;
    }
    h2 {
      font-size: 17px;
      font-weight: bold;
      padding-bottom: 10px;
    }
    p {
      font-size: 0.9rem;
      @include avenir();
      line-height: 1.7;
    }
    .content {
      padding-bottom: 20px;
      a {
        color: $red;
        font-weight: 400;
        text-decoration: none;
        &:active {
          opacity: 0.7;
        }
      }
      img {
        width: 100%;
      }
    }
  }
}
</style>
